import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "affiliate-footer-bar" }
const _hoisted_2 = { class: "affiliate-footer-bar__container" }
const _hoisted_3 = { class: "affiliate-footer-bar__left-container" }
const _hoisted_4 = {
  key: 2,
  class: "affiliate-footer-bar__notification"
}
const _hoisted_5 = { class: "affiliate-footer-bar__right-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_ElCheckbox = _resolveComponent("ElCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.shouldShowElements)
          ? (_openBlock(), _createBlock(_component_PxButton, _mergeProps({ key: 0 }, _ctx.saveAsDraftButtonProps, {
              loading: _ctx.isSaving,
              class: "affiliate-footer-bar__draft-button",
              onClick: _ctx.saveDraft
            }), null, 16, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.shouldShowConsentButton)
          ? (_openBlock(), _createBlock(_component_ElCheckbox, {
              key: 1,
              modelValue: _ctx.sdgConsent,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sdgConsent) = $event)),
              class: "checkbox"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" By submitting this form, I agree to share data provided in accordance with Abaca's ", -1),
                _createElementVNode("a", { href: "https://abaca.app/terms-of-use" }, "Terms of Use", -1),
                _createTextVNode(" and ", -1),
                _createElementVNode("a", { href: "https://abaca.app/terms-of-use" }, "Privacy Policy", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.date && _ctx.shouldShowElements)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("affiliateProgram.footerBar.update", {
              date: _ctx.date,
            })), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PxButton, _mergeProps(_ctx.previousButtonProps, {
          loading: _ctx.isSaving,
          class: "affiliate-footer-bar__previous-button",
          onClick: _ctx.goToPreviousStep
        }), null, 16, ["loading", "onClick"]),
        _createVNode(_component_PxButton, _mergeProps(_ctx.nextButtonProps, {
          disabled: _ctx.buttonIsDisabled,
          loading: _ctx.isSaving,
          class: "affiliate-footer-bar__next-button",
          onClick: _ctx.goToNextStep
        }), null, 16, ["disabled", "loading", "onClick"])
      ])
    ])
  ]))
}